import { auth, googleProvider } from "@/firebase";
import { createUserWithEmailAndPassword, signInWithPopup } from "firebase/auth";

export default {
    namespaced: true,

    state: {},
    mutations: {},

    actions: {
        async handleAuth(context, payload) {

            const { email, password, fullName, router } = payload;
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;

            const userData = {
                id: user.uid,
                email: user.email,
                displayName: fullName,
                password: password
            };

            localStorage.setItem('user', JSON.stringify(userData));
            localStorage.removeItem('guestCart');

            context.dispatch('checkLoggedIn', null, {root: true});

            router.push(`/Profile/${userData.id}`);
        },

        async signInWithGoogle(context, router) {

            const userCredential = await signInWithPopup(auth, googleProvider);
            const user = userCredential.user;

            const userData = {
                id: user.uid,
                email: user.email,
                displayName: user.displayName || "Google User",
            };

            localStorage.setItem('user', JSON.stringify(userData));
            localStorage.removeItem('guestCart');
            
            context.dispatch('checkLoggedIn', null, {root: true});

            router.push(`/Profile/${userData.id}`)
            
        }

    },
    getters: {},
}